import { InputOverLimitWarningSlot } from '#pplx/frontend/composer-sdk-plugins/input-over-limit-warning/InputOverLimitWarning.js';
import { createPluginFactory } from '#pplx/frontend/composer-sdk/plugins/createPluginFactory.js';
/**
 * Creates a warning that renders only when `count` exceeds `limit`. Keep it
 * registered while it owns `inputHeader`; consumers own the limit, localized
 * formatter, and Submit policy. Recreated instances update live props under
 * the same stable plugin identity.
 */
export function createInputOverLimitWarningPluginFactory() {
    return createPluginFactory({
        name: 'input-over-limit-warning',
        capabilities: [
            { kind: 'slot', components: [{ slot: 'inputHeader', component: InputOverLimitWarningSlot }] },
        ],
    });
}
//# sourceMappingURL=inputOverLimitWarningPlugin.js.map